import { Box, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { AttendeeState, MeetingAttendee } from "../../meetings/meetingTypes"
import { StandardChip } from "../../../../../../shared/components/badges/StandardChip"

const useStyles = makeStyles()(() => ({
    container: {
        display: "flex",
        cursor: "pointer",
        border: "1px solid transparent",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: ".75rem .5rem",
    },
    hoverBlue: {
        "&:hover": {
            borderRadius: ".75rem",
            border: `1px solid ${tailwindPalette.blue[500]}`,
            backgroundColor: tailwindPalette.blue[50],
        },
    },
    hoverGray: {
        "&:hover": {
            borderRadius: ".75rem",
            border: `1px solid ${tailwindPalette.slate[300]}`,
            backgroundColor: tailwindPalette.slate[100],
        },
    },
    activeItem: {
        borderRadius: "0.75rem",
        border: `1px solid ${tailwindPalette.blue[500]}`,
        backgroundColor: tailwindPalette.blue[50],
    },
    guestInfo: {
        display: "flex",
        flexDirection: "column",
        gap: "0.25rem",
    },
    companyRow: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
    },
    icon: {
        color: tailwindPalette.slate["400"],
        width: "1rem",
    },
}))

type GuestItemProps = {
    attendee: MeetingAttendee
    onSelect: (id: number) => void
    selectedIds?: number[]
}

export function GuestItem({ attendee, onSelect, selectedIds }: GuestItemProps) {
    const { id, name, companyName, state } = attendee
    const { classes, cx } = useStyles()

    const isSelected = selectedIds?.includes(id)

    return (
        <Box
            className={cx(classes.container, isSelected ? classes.hoverBlue : classes.hoverGray, {
                [classes.activeItem]: isSelected,
            })}
            onClick={() => onSelect(id)}
        >
            <Box className={classes.guestInfo}>
                <Stack direction="row" alignItems="center" gap={1}>
                    <Typography fontWeight={500}>{name}</Typography>
                    {state === AttendeeState.CHECKED_IN && (
                        <LocalizedStrict id="service-center-reports-dashboard-checked-id">
                            <StandardChip variant="success">Checked In</StandardChip>
                        </LocalizedStrict>
                    )}
                </Stack>
                <Box className={classes.companyRow}>
                    <Typography color={tailwindPalette.slate["500"]} variant="body2">
                        {companyName}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}
